export default {
  Status: {
    IsPayment: 'đã thanh toán',
    IsReceiptExpense: 'đã ghi thu, ghi chi',
    IsFromDvc: 'đã nộp Hồ sơ KBĐT'
  },
  ShowNotiDelete: {
    Message: 'Chứng từ ',
    Title: 'Không thể xóa',
    TitleDelete: 'Xóa bảng kê',
    Button: 'Đồng ý',
    CreateFromDvcFile:
      'Bảng kê được sinh ra từ hồ sơ KBĐT với trạng thái KBNN thông báo kết quả xử lý thanh toán. Bạn có thật sự muốn xóa bảng kê không?',
  },
};
